import { render, staticRenderFns } from "./DrawButtonPalette.vue?vue&type=template&id=3ad9d73c&scoped=true&"
import script from "./DrawButtonPalette.vue?vue&type=script&lang=js&"
export * from "./DrawButtonPalette.vue?vue&type=script&lang=js&"
import style0 from "./DrawButtonPalette.vue?vue&type=style&index=0&id=3ad9d73c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad9d73c",
  null
  
)

export default component.exports